import React from 'react';

export default function OutlookNotLinkedText() {
  return (
    <>
      <p>
        <b>MS Office 365</b>
        {' '}
        account is not linked.
      </p>
      <p>Connect your account by clicking the MS Office 365 button.</p>
    </>
  );
}
